import { render, staticRenderFns } from "./Unim.vue?vue&type=template&id=6136ea54&scoped=true"
import script from "./Unim.vue?vue&type=script&lang=js"
export * from "./Unim.vue?vue&type=script&lang=js"
import style0 from "./Unim.vue?vue&type=style&index=0&id=6136ea54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6136ea54",
  null
  
)

export default component.exports